import React from 'react';
import { format as formatDate, isValid, parse } from 'date-fns';
import { cs } from 'date-fns/locale';

import "./DateTime.scss";

const toDate = any=>{
    const tp = typeof any;
    if (tp === "string") { any = new Date(any); }
    else if (tp === "number") { any = new Date(any); }

    if (isValid(any)) { return any; }
}

export const DateTime = (props)=>{
    const { value, format } = props;

    const v = toDate(value);

    if (!v) { return null; }

    const f = format ?? "d.M.yyyy";

    formatDate(v, f, { locale: cs })

    return (
        <span className="DateTime">{formatDate(v, f, { locale: cs })}</span>
    )
}

